// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1Lbpp","col":"Table_col__-RoDh","fulfillmentStatus":"Table_fulfillmentStatus__pTpiR","emailCol":"Table_emailCol__1gN2W"};